module.exports = __webpack_public_path__ + "static/media/4.6af7b1f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/4.png
// module id = 818
// module chunks = 0